<div class="status-panel">
  <ng-container *ngTemplateOutlet="activeInfo"></ng-container>
  <ng-container *ngTemplateOutlet="countdown"></ng-container>
  <div *ngIf="application | option as app">Bis zum {{ app.cycle.feedback | moment: 'date' }} melden wir uns bei dir per E-Mail.</div>
  <!-- Button -->
  <ng-container [ngSwitch]="buttonStatus">
    <ng-container *ngSwitchCase="'apply'">
      <div>
        <markant-button class="button pink primary action pitch" (click)="apply()">Bewerbung final einreichen</markant-button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'thanks'">
      <div style="margin-top: 1vh">
        <markant-button disabled="true">Danke für Deine Bewerbung</markant-button>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'applydisabled'">
      <div>
        <markant-button class="button pink primary disabled action pitch">Bewerbung final einreichen</markant-button>
      </div>
    </ng-container>
  </ng-container>
</div>

<!-- Templates -->
<ng-template #activeInfo>
  <h3 class="activeInfo dashboard-box-header">{{ cycle.name }} am {{ cycle.pitchDate | moment: 'date' }} in {{ cycle.location }}</h3>
  <div class="apply_info" *ngIf="shouldShowApplyInfoText()">
    <p class="apply_info_text">
      Erstelle Deine Bewerbung bitte über die Reiter „Profil“ sowie „Produkt“ und reiche Deine Bewerbung erst nach Fertigstellung über den unteren Button final
      ein.
    </p>
    <markant-icon class="apply_info_icon" icon="m_info"></markant-icon>
  </div>
</ng-template>

<ng-template #countdown>
  <ng-container *ngIf="beforeApplicationOpen(cycle)">
    <!-- Der Countdown hat noch nicht angefangen -->
    Der Bewerbungszeitraum dauert vom {{ cycle.applicationStart | moment: 'date' }} bis zum {{ cycle.applicationEnd | moment: 'date' }}. <br />
  </ng-container>

  <ng-container *ngIf="inApplicationPeriod(cycle)">
    <!-- Bewerbung offen, einen richtigen Countdown-Timer anzeigen -->
    <ng-container *ngIf="daysUntilApplicationEnd >= 1">
      <div class="remaining" *ngIf="daysUntilApplicationEnd > 1">
        <div class="remainingText">Bewerbungsschluss ist in</div>
        <span class="number">{{ daysUntilApplicationEnd }}</span> Tagen
      </div>
      <div class="remaining" *ngIf="daysUntilApplicationEnd == 1">
        <div class="remainingText">Bewerbungsschluss ist</div>
        <span class="number">morgen </span>
      </div>
    </ng-container>
    <ng-container *ngIf="daysUntilApplicationEnd == 0">
      <div class="remainingText">Bewerbungsschluss ist</div>
      <div class="today" *ngIf="daysUntilApplicationEnd < 1">heute</div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="afterApplicationClosed(cycle) && !inApplicationPeriod(cycle)">
    <!-- Bewerbung vorbei -->
    <div class="remainingText">Der Bewerbungszeitraum ist leider schon vorbei. Bewirb dich doch auf den nächsten Pitch!</div>
  </ng-container>
</ng-template>
